import { useEffect } from 'react'

import Grid from '../components/grid'
import { setCurrentPath } from '../state/ui'
import { useMyHistory } from '../queries/media'

export default function MyHistory() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useMyHistory()

  useEffect(() => {
    setCurrentPath([])
  }, [])

  return (
    <Grid
      shows={data ?? []}
      infiniteFunc={() => {
        if (hasNextPage && !isFetchingNextPage) fetchNextPage()
      }}
    />
  )
}
